import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFilterStore } from '../store';

export function useUrlFiltersSync() {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    selectedMonth,
    setSelectedMonth,
    selectedCategoryId,
    setSelectedCategoryId,
    searchQuery,
    setSearchQuery,
  } = useFilterStore();

  useEffect(() => {
    const urlMonth = searchParams.get('month');
    const urlCategory = searchParams.get('category');
    const urlSearch = searchParams.get('search');

    if (urlMonth !== null) setSelectedMonth(urlMonth);
    if (urlCategory !== null) setSelectedCategoryId(urlCategory);
    if (urlSearch !== null) setSearchQuery(urlSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const params = new URLSearchParams();
    if (selectedMonth) params.set('month', selectedMonth);
    if (selectedCategoryId) params.set('category', selectedCategoryId);
    if (searchQuery) params.set('search', searchQuery);

    setSearchParams(params, { replace: true });
  }, [selectedMonth, selectedCategoryId, searchQuery, setSearchParams]);
}
